module.exports = __webpack_public_path__ + "img/nu.d93e5ff7.svg";